import React, { useEffect, useState } from 'react'
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import '../style.scss'
import { useParams } from 'react-router-dom';
import TableGridView from "../../TableGridView";
import { deleteAppointmentRequest, getAppointmentsRequest } from '../../../store/appointments/actions';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';
import ConfirmDialog from '../../ConfirmDialog/ConfirmDialog';
import { useHistory } from 'react-router-dom';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';

function MedicalAppointments({ intl: { messages }, setEditApp, disabled }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const { appointments } = useSelector((state) => state.appointments);
    const [selectedAppointment, setSelectedAppointment] = useState(null);
    const [deleteConfirmation, setDeleteConfirmation] = useState(false);
    const { id } = useParams();

    useEffect(() => {
       if (id) {
            dispatch(getAppointmentsRequest({ patientId: id, sort: 'created_at,desc' }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);
    
    //table n grid view render
  const headings = [
    messages.patients.appointments.app_status,
    messages.patients.appointments.app_type,
    messages.patients.appointments.specialist_name,
    messages.patients.appointments.app_date,
    messages.patients.appointments.status,
    messages.patients.appointments.actions,
  ];

  const renderTableData = () => {
    return appointments?.data?.map((app, i) => {
      const { purpose_name, type, type_name, user_name, start_date, status_name, call_recording_url } =
        app;
      return [
        <span className='link_span' onClick={() => history.push(`/appointment/${app.id}`)}>{purpose_name}</span>,
        type_name,
        user_name,
        moment(start_date).format("dddd,\xa0 DD MMMM YYYY, h:mm a"),
        status_name,
        <div className="table-actions">
          <DeleteForeverIcon onClick={() => {
            if (!disabled) {
              setSelectedAppointment(app);
              setDeleteConfirmation(true);
            }
            }} />
          <EditIcon onClick={() => !disabled && setEditApp(app)} />
          { type === 2 && call_recording_url && <a href={call_recording_url} target="_blank" rel="noopener noreferrer">
            <PlayCircleOutlineIcon style={{ color: "rgba(237, 166, 40, 1)", cursor: "pointer", fontSize: "24px", margin: "0 5px" }} />
          </a> }
        </div>,
      ];
    });
  };
  
    const handlePageChange = (e, page) => {
        return dispatch(
          getAppointmentsRequest({
              page,
              patientId: id,
              sort: 'created_at,desc',
          })
        );
    };

    if (appointments?.data?.length > 0) {
      return (
        <div style={{ width: '100%' }} className='myscrollbar-container'>
            {appointments ? (
              <TableGridView
                title={null}
                Form={null}
                table={{
                  stickyHeader: true,
                  headings: headings,
                  data: renderTableData(),
                  headClass: "bg-white table-head",
                  noData: messages.noData.no_data,
                }}
                pagination={{
                  count: appointments.last_page,
                  page: appointments.current_page,
                  handleChange: handlePageChange,
                }}
              />
            ) : null}
            <ConfirmDialog show={deleteConfirmation} 
                  onCancel={() => setDeleteConfirmation(false)}
                  onConfirm={() => {
                      dispatch(deleteAppointmentRequest(selectedAppointment.id));
                      setDeleteConfirmation(false);
                  }}
                  icon={null}
                  content={messages.patients.appointments.confirmDelete}
                  cancelBtn={messages.warningMsgs.cancel}
                  confirmBtn={messages.warningMsgs.confirm} />
          </div>
        );
    } else {
      return (
        <div className="no-data-block">
            {messages.appointments.noAppointments}
        </div>
      )
    }
}

export default injectIntl(MedicalAppointments)